import React, { useState, useEffect } from 'react';

const JoinLobby = ({ onJoinLobby, loading, error, onBack }) => {
  const [lobbyCode, setLobbyCode] = useState('');
  const [playerName, setPlayerName] = useState('');

  // Log component lifecycle
  useEffect(() => {
    console.log('[JoinLobby] Component mounted/updated', {
      lobbyCode,
      playerName,
      loading,
      hasError: !!error
    });
  }, [lobbyCode, playerName, loading, error]);

  const handleJoinLobby = () => {
    if (!lobbyCode.trim() || !playerName.trim()) {
      console.log('[JoinLobby] Lobby code and player name are required');
      return;
    }
    
    console.log('[JoinLobby] Joining lobby with:', {
      lobbyCode: lobbyCode.trim().toUpperCase(),
      playerName: playerName.trim()
    });
    
    onJoinLobby(lobbyCode.trim().toUpperCase(), playerName.trim());
  };

  const handleLobbyCodeChange = (e) => {
    // Auto-uppercase and limit to 6 characters
    const value = e.target.value.toUpperCase().slice(0, 6);
    setLobbyCode(value);
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleJoinLobby();
    }
  };

  return (
    <div className="game-card">
      <h1><span role="img" aria-label="key">🔑</span> Join Lobby</h1>
      <p>Enter the lobby code to join a multiplayer game!</p>
      
      <div className="join-settings">
        <div className="setting-group">
          <label>Lobby Code:</label>
          <input
            type="text"
            value={lobbyCode}
            onChange={handleLobbyCodeChange}
            onKeyPress={handleKeyPress}
            placeholder="Enter 6-character code"
            className="lobby-code-input"
            maxLength={6}
            style={{
              textTransform: 'uppercase',
              letterSpacing: '0.2em',
              textAlign: 'center',
              fontSize: '1.2em',
              fontWeight: 'bold'
            }}
          />
        </div>
        
        <div className="setting-group">
          <label>Your Name:</label>
          <input
            type="text"
            value={playerName}
            onChange={(e) => setPlayerName(e.target.value)}
            onKeyPress={handleKeyPress}
            placeholder="Enter your name"
            className="player-name-input"
            maxLength={20}
          />
        </div>
      </div>
      
      <div className="button-group">
        <button 
          className="back-button" 
          onClick={onBack}
        >
          ← Back
        </button>
        
        <button 
          className="start-button" 
          onClick={handleJoinLobby}
          disabled={loading || !lobbyCode.trim() || !playerName.trim() || lobbyCode.length !== 6}
        >
          {loading ? 'Joining...' : 'Join Lobby'}
        </button>
      </div>
      
      {error && <div className="error">{error}</div>}
    </div>
  );
};

export default JoinLobby;
